import React, { useState, useRef } from 'react'
import CursorIcon from './icons/cursor'
import { useMutation } from '@apollo/react-hooks'
import UploadDocuments from '../../queries/UploadDocuments'
import { useSnackbar } from '../../contexts/SnackbarContext'
import {
  ContainerElement,
  TextElement,
  UnderlineTextElement,
  HiddenInputElement,
} from './elements'

function Upload({ documentId, preventUpload }) {
  const [isDragging, setIsDragging] = useState(false)
  const { setSuccessMessage, setErrorMessage } = useSnackbar()
  const hiddenFileInputRef = useRef(null)

  const [uploadDocumentsMutation, { loading: isUploading }] = useMutation(
    UploadDocuments,
    {
      onCompleted: () => setSuccessMessage('Document successfully updated'),
      onError: () =>
        setErrorMessage('There was an error uploading the document'),
    }
  )

  const uploadFiles = (files) => {
    setIsDragging(false)

    uploadDocumentsMutation({
      variables: {
        input: {
          documentId,
          files,
          sync: true,
          fileStatus: null,
          referenceDate: new Date().toISOString(),
        },
      },
    })
  }

  const handleDragOver = (e) => {
    e.preventDefault()
    !preventUpload && setIsDragging(true)
  }

  const handleDragLeave = (e) => {
    e.preventDefault()
    !preventUpload && setIsDragging(false)
  }

  const handleDrop = (e) => {
    e.persist()
    e.preventDefault()
    !preventUpload && uploadFiles(e.dataTransfer.files)
  }

  const handleHiddenInputChange = (e) => {
    e.persist()
    e.preventDefault()
    !preventUpload && uploadFiles(e.target.files)
  }

  return (
    <ContainerElement
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={() => hiddenFileInputRef.current.click()}
      isUploading={isUploading}
      disabled={preventUpload}
    >
      {!isUploading && <CursorIcon />}
      <TextElement>
        {isUploading ? (
          'Uploading...'
        ) : isDragging ? (
          'Drop the document here to upload it'
        ) : (
          <>
            Drag document here or{' '}
            <UnderlineTextElement>upload a file</UnderlineTextElement>
          </>
        )}
      </TextElement>
      <HiddenInputElement
        multiple
        type="file"
        innerRef={hiddenFileInputRef}
        onChange={handleHiddenInputChange}
      />
    </ContainerElement>
  )
}

export default Upload
